import React, { useState } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import IndexModal from ".";

export default function HeaderModal( props ) {
 const { open, onClose, icon, width="600px", title, cardBorder, titleClass, description, descriptionClass, children, bgcolor, colorTheme, labelIcon, rightNav, footer, closable=true, backgroundStyle, useCustomClass="true" , group } = props;

 const modalClassName = [
    useCustomClass ? "custom-ant-modal-content" : "",
    typeof width === "string" ? width : "",
  ]
  .filter(Boolean)
  .join(" ");

  return (
    <>
      <IndexModal
        open={open}
        onCancel={onClose} 
        footer={null}
        width={{
          xs: '98%',
          sm: '98%',
          md: '90%',
          lg: '70%',
        }}
        className={modalClassName}
        closable={closable}
        style={{ maxWidth: width, margin: "0 auto" }}
      >
        <div className={group}>
            <HeaderComponent
              icon={icon}
              title={title}
              titleClass={titleClass}
              description={description}
              descriptionClass={descriptionClass}
              bgcolor={bgcolor}
              cardBorder={cardBorder}
              colorTheme={colorTheme}
              labelIcon={labelIcon}
              backgroundStyle={backgroundStyle}
              rightNav={rightNav}
              footer={footer}
            >
              {children}
            </HeaderComponent>
        </div>
         
      </IndexModal>
    </>
  );
}
